<template>
  <modal-component :display-value="true">
    <div class="dark:text-kanban-white">
      <img src="@/assets/logo-light.svg" class="hidden dark:block" alt="" />
      <img src="@/assets/logo-dark.svg" class="dark:hidden block" alt="" />
      <h3 class="font-bold text-lg capitalize mt-[60px]">Signup</h3>
      <div id="login-container" class="mt-6">
        <input-component
          v-model="email.value"
          label="Username"
          placeholder="John@gmail.com"
          :false-value="email.falseValue"
        />
        <input-component
          v-model="password.value"
          label="Password"
          placeholder="Password"
          input-type="password"
          :false-value="password.falseValue"
          custom-class="mt-5"
        />
      </div>
      <div
        v-if="loading"
        class="bg-kanban-main-purple w-full py-2 rounded-3xl flex justify-center mt-6"
      >
        <loader />
      </div>
      <action-button
        v-else
        :danger-button="false"
        class="mt-6 text-kanban-white capitalize"
        @click="signup"
      >
        Signup
      </action-button>
      <p class="text-xs mt-6 text-kanban-medium-grey">
        Already have an account?
        <span class="text-kanban-white underline font-bold ml-[4px]">
          <router-link to="/auth/login"> Login </router-link>
        </span>
      </p>
    </div>
  </modal-component>
</template>

<script>
import ModalComponent from "../shared/ModalComponent.vue";
import Loader from "../shared/LoaderComponent.vue";
import InputComponent from "../shared/InputComponent.vue";
import ActionButton from "../shared/ActionButton.vue";

import { validate } from "../../helper/validation";

export default {
  components: {
    ModalComponent,
    Loader,
    InputComponent,
    ActionButton,
  },
  data() {
    return {
      loading: false,
      email: {
        value: "",
        falseValue: false,
      },
      password: {
        value: "",
        falseValue: false,
      },
    };
  },

  methods: {
    async signup() {
      // check email
      this.email.falseValue = !validate.validateEmail(this.email.value);
      //   check password
      this.password.falseValue = !validate.validatePassword(
        this.password.value
      );

      if (!(this.email.falseValue || this.password.falseValue)) {
        this.loading = true;
        await this.$store.dispatch("auth/signUpUser", {
          email: this.email.value,
          password: this.password.value,
        });
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.auth-password {
  margin-top: 2;
}
</style>